// extracted by mini-css-extract-plugin
export default {"bio":"e-","about":"f-","title":"g-","text":"h-","fun_facts":"i-","fun":"j-","icon":"k-","bio_header":"l-"};
    if(module.hot) {
      // 1715091684832
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  